export default function closePopup() {
	return (dispatch) => {
		dispatch({
			type: 'CLOSE_POPUP',
		});
	};
}